module.exports = __webpack_public_path__ + "img/empty.052e41b6.png";